import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Check, Shield, Heart, Sparkles, User } from 'lucide-react';
import { mockTestimonials } from '../mockData';

const Home = () => {
  const ctaUrl = 'https://prodentim24.com/text.php#aff=RafaelAndradeVitorio';

  const benefits = [
  { icon: Heart, text: 'Your gums stop bleeding when you brush' },
  { icon: Sparkles, text: 'Your breath smells fresh without mints' },
  { icon: Shield, text: 'Your gums feel healthy and look pink again' },
  { icon: Check, text: 'You can talk close to people without worry' }];


  return (
    <div className="min-h-screen bg-[#faf8f5]">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-[#e8e4dc] sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="text-2xl font-semibold text-[#5a6f5c]">Oral Health Discovery</div>
            <Button
              onClick={() => window.open(ctaUrl, '_blank')}
              className="bg-[#7a9c7d] hover:bg-[#6a8c6d] text-white transition-all duration-300">

              Learn More
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section
        className="relative py-32 px-6 bg-cover bg-center"
        style={{
          backgroundImage: 'linear-gradient(rgba(250, 248, 245, 0.85), rgba(250, 248, 245, 0.85)), url(https://images.pexels.com/photos/289586/pexels-photo-289586.jpeg)'
        }}>

        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-[#3d4f3e] mb-6 leading-tight">
            Why Do Your Gums Keep Bleeding Every Time You Brush?
          </h1>
          <p className="md:text-2xl !text-xl mb-8 text-[#6a7a6b]">Dentists say it’s not what you think

          </p>
          <div className="h-1 w-24 bg-[#a8c5aa] mx-auto rounded-full"></div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-3xl mx-auto">
          <div className="prose prose-lg max-w-none text-[#4a5a4b]">
            <p className="text-lg leading-relaxed mb-6">
              Sarah was terrified to smile. Terrified to talk close to people.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              Every morning, she brushed. Every morning, she spit out blood. Every morning, she checked her breath. Every morning, it smelled bad.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              She used mouthwash. She chewed gum constantly. She kept mints in her purse, her car, her desk.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              Nothing worked. She felt disgusting.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              Her dentist kept saying the same thing. "Brush more. Floss more."
            </p>
            <p className="text-lg leading-relaxed mb-6">
              But she WAS brushing. She WAS flossing. And her gums kept bleeding. Her breath kept smelling.
            </p>
            <p className="!text-lg mb-6">Finally, she broke down crying in the dentist chair.
If this sounds familiar, you’re not alone.
            </p>
            <div className="bg-[#f4f7f4] border-l-4 border-[#7a9c7d] p-6 my-8 rounded-r-lg">
              <p className="!font-medium !text-xl !italic text-[#3d4f3e]">"Your gums may be bleeding because you’re removing bacteria your mouth actually needs."

              </p>
            </div>
            <p className="text-lg leading-relaxed">
              That's when everything started to make sense.
            </p>
          </div>
        </div>
      </section>

      {/* Authority Section */}
      <section className="py-20 px-6 bg-[#f9f6f1]">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3d4f3e] mb-8 text-center">
            Why Your Gums Bleed and Your Breath Stinks
          </h2>
          <div className="space-y-6 text-lg leading-relaxed text-[#4a5a4b]">
            <p>
              Your mouth needs good bacteria to stay healthy.
            </p>
            <p>
              This bacteria stops gum bleeding. It kills the bad bacteria that makes your breath smell.
            </p>
            <p className="!font-medium !text-xl text-[#5a6f5c]">Most toothpastes remove both good and bad bacteria.

            </p>
            <p>
              So your gums have no protection. They bleed.
            </p>
            <p>
              And the bad bacteria comes back. Your breath smells. Again.
            </p>
            <p className="font-medium text-[#3d4f3e] text-xl">
              You're not dirty. You're not lazy. Your mouth just needs help.
            </p>
          </div>
        </div>
      </section>

      {/* Product Introduction */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3d4f3e] mb-8 text-center">
            How to Stop the Bleeding and Fix Your Breath
          </h2>
          <div className="space-y-6 text-lg leading-relaxed text-[#4a5a4b]">
            <p>ProDentim was created to help support the good bacteria your mouth needs.

            </p>
            <p>
              The bacteria that stops gum bleeding.
            </p>
            <p>
              The bacteria that fights bad breath at the source.
            </p>
            <p className="font-medium text-[#5a6f5c]">
              You don't brush harder. You give your mouth what it's missing.
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-[#f4f7f4] to-[#faf8f5]">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3d4f3e] mb-12 text-center">
            What People Are Experiencing
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <Card key={index} className="border-[#e8e4dc] bg-white hover:shadow-lg transition-all duration-300">
                  <CardContent className="p-8 flex items-start space-x-4">
                    <div className="bg-[#e8f2e9] p-3 rounded-lg">
                      <Icon className="w-6 h-6 text-[#7a9c7d]" />
                    </div>
                    <p className="text-lg text-[#4a5a4b] font-medium pt-2">{benefit.text}</p>
                  </CardContent>
                </Card>);

            })}
          </div>
        </div>
      </section>

      {/* Objection Handling */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3d4f3e] mb-8 text-center">
            What If You Could Finally Stop Worrying?
          </h2>
          <div className="space-y-6 text-lg leading-relaxed text-[#4a5a4b]">
            <p>
              What if you woke up and your sink wasn't full of blood?
            </p>
            <p>
              What if you could talk to someone and not think about your breath?
            </p>
            <p>
              What if you could kiss someone without being scared?
            </p>
            <p className="font-medium text-[#5a6f5c]">
              What if your gums could actually heal?
            </p>
            <p>
              This isn't about hoping. This is about fixing the real problem.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-6 bg-[#f9f6f1]">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3d4f3e] mb-12 text-center">
            Real People. Real Results.
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {mockTestimonials.map((testimonial, index) =>
            <Card key={index} className="border-[#e8e4dc] bg-white">
                <CardContent className="p-8">
                  <div className="flex items-center mb-4">
                    <div className="bg-[#7a9c7d] rounded-full w-12 h-12 flex items-center justify-center">
                      <User className="w-6 h-6 text-white" />
                    </div>
                    <div className="ml-4">
                      <p className="font-semibold text-[#3d4f3e]">{testimonial.name}</p>
                      <p className="text-sm text-[#6a7a6b]">{testimonial.location}</p>
                    </div>
                  </div>
                  <p className="text-[#4a5a4b] leading-relaxed italic">"{testimonial.text}"</p>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-24 px-6 bg-gradient-to-br from-[#7a9c7d] to-[#6a8c6d] text-white">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Stop the Bleeding. Fix Your Breath.
          </h2>
          <p className="text-xl mb-10 text-white/90 leading-relaxed">
            Watch this video. It explains why your gums bleed and why your breath smells. And what you can do about it right now.
          </p>
          <Button
            onClick={() => window.open(ctaUrl, '_blank')}
            size="lg"
            className="inline-flex items-center justify-center whitespace-nowrap focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-10 hover:bg-[#f9f6f1] transition-all duration-300 hover:shadow-2xl hover:scale-105 !font-semibold !text-lg gap-2 px-12 py-6 rounded-md shadow-xl text-[#5a6f5c] bg-white">See How This Works


          </Button>
          <p className="mt-6 text-sm text-white/70">You deserve to feel confident again</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#3d4f3e] text-white/80 py-12 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-sm mb-4">
            This is an advertisement and not an actual news article, blog, or consumer protection update.
          </p>
          <p className="text-sm mb-4">
            Results may vary from person to person. These statements have not been evaluated by the Food and Drug Administration. 
            This product is not intended to diagnose, treat, cure, or prevent any disease.
          </p>
          <p className="text-xs text-white/60 mt-6">
            © 2025 Oral Health Discovery. All rights reserved.
          </p>
        </div>
      </footer>
    </div>);

};

export default Home;